import type { ReactElement } from 'react';
import { ContextSelectorContainer } from './ContextSelector.Container';
import { ChatHeaderController } from './Header.Controller';

type Props = {
  disableContextDisplay?: boolean;
  disableTabs?: boolean;
};

function ChatHeader(props: Props): ReactElement {
  return (
    <ContextSelectorContainer>
      <ChatHeaderController
        disableContextDisplay={props.disableContextDisplay}
        disableTabs={props.disableTabs}
      />
    </ContextSelectorContainer>
  );
}

export { ChatHeader };
